import * as api from '../util/api';
import useAuthToken from '../hooks/useAuthToken';

export interface IEvent {
    name?: string;
    url?: string;
    action: string;
    type?: string;
}
export default function useAudit() {
    const token = useAuthToken();
    const captureEvent = ({ name, url, action, type }: IEvent) => {
        (async () => {
            try {
                await api.captureEvent({ name, url, action, type }, token);
            } catch (err) {
                console.error('Error capturing event:', err);
            }
        })();
    };
    return { captureEvent }
}
